<template>
  <div>
    <md-dialog :md-active.sync="showDialog" v-on:md-closed="closed">
      <div class="content-dialog">
        <div class="loading-overlay" v-if="!loadDialog">
          <md-progress-spinner :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
        </div>
        <md-dialog-title>Редактирование магазина</md-dialog-title>
        <form novalidate class="md-layout">
          <md-card class="md-layout-item">
            <md-card-content>
              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('name')">
                    <label for="first-name">Название</label>
                    <md-input name="first-name" id="first-name" autocomplete="given-name" v-model="form.name"
                              disabled="disabled"/>
                  </md-field>
                </div>

                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('register_name')">
                    <label for="last-name">Юридическое название</label>
                    <md-input name="last-name" id="last-name" autocomplete="family-name" v-model="form.registry_name"
                              disabled="disabled"/>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('gender')">
                    <label for="tnn">БИН</label>
                    <md-input name="tnn" id="tnn" autocomplete="family-name" v-model="form.tin" disabled="disabled"/>
                  </md-field>
                </div>

              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field>
                    <label for="terminal_number">Номер терминала</label>
                    <md-input name="terminal_number" id="terminal_number" autocomplete="family-name" maxlength="20"
                              v-model="form.terminal_number"/>
                  </md-field>
                </div>
              </div>

              <md-field>
                <label for="city">{{ t('shop.title.cities') }}</label>
                <md-select v-model="form.city_id" name="city" id="city">
                  <md-option value="deleteFilter" :key="'deleteFilter'">{{ t('shop.select.option.all') }}</md-option>
                  <md-option v-for="v in cityList"
                             :value="v.id"
                             :key="v.id">{{ v.name }}
                  </md-option>
                </md-select>
              </md-field>

              <md-field>
                <label for="status">Статус</label>
                <md-select v-model="form.status_id" name="status" id="status">
                  <md-option value="1" :key="'status_1'">Активный</md-option>
                  <md-option value="0" :key="'status_2'">Неактивный</md-option>
                </md-select>
              </md-field>

              <md-field v-if="this.country_code === 'kz'">
                <label for="is_acquiring_enabled">Включен Tap2Phone</label>
                <md-select v-model="form.is_tap2phone_enabled" name="is_tap2phone_enabled" id="is_tap2phone_enabled">
                  <md-option value="1" :key="'ekv_1'">Да</md-option>
                  <md-option value="0" :key="'ekv_0'">Нет</md-option>
                </md-select>
              </md-field>

              <md-field>
                <label for="isWork">Включено управление сменами</label>
                <md-select v-model="form.is_check_operday_enabled" name="isWork" id="isWork">
                  <md-option value="1" :key="'status_1'">Да</md-option>
                  <md-option value="0" :key="'status_2'">Нет</md-option>
                </md-select>
              </md-field>

              <md-field>
                <label for="openWork">Открытие смены</label>
                <md-select v-model="form.working_hours_from" name="openWork" id="openWork">
                  <md-option v-for="v in timeInterval"
                             :value="v"
                             :key="v">{{ v }}
                  </md-option>
                </md-select>
              </md-field>

              <md-field>
                <label for="closeWork">Закрытие смены</label>
                <md-select v-model="form.working_hours_to" name="closeWork" id="closeWork">
                  <md-option v-for="v in timeInterval"
                             :value="v"
                             :key="v">{{ v }}
                  </md-option>
                </md-select>
              </md-field>
            </md-card-content>
            <md-progress-bar md-mode="indeterminate" v-if="sending"/>

          </md-card>

          <md-snackbar :md-active.sync="userSaved">The user {{ lastUser }} was saved with success!</md-snackbar>
        </form>
        <md-dialog-actions>
          <md-button class="md-primary ct-red pointer" @click="resetPassword">Сбросить пароль</md-button>
          <md-button class="md-primary ct-yellow pointer" @click="showDialog = false">Закрыть</md-button>
          <md-button class="md-primary ct-green pointer" @click="submitForm">Сохранить</md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import {validationMixin} from 'vuelidate'
import HttpClient from '@/api/calls'
import Responses from '@/api/responses'
import cacheCt from '@/cahces/cities'
export default {
  name: 'EditDialog',
  mixins: [validationMixin],
  data: () => ({
    form: {
      name: null,
      registry_name: null,
      tin: null,
      status_id: null,
      is_acquiring_enabled: null,
      is_tap2phone_enabled: null,
      is_check_operday_enabled: null,
      working_hours_from: null,
      working_hours_to: null,
      city_id: null
    },
    successSave: false,
    userSaved: false,
    sending: false,
    lastUser: null,
    showDialog: false,
    cityList: [],
    loadDialog: false,
    userData: {},
    deactiveUsers: 0,
    terminal_number: '',
    timeInterval: [
      '00:00', '00:30',
      '01:00', '01:30',
      '02:00', '02:30',
      '03:00', '03:30',
      '04:00', '04:30',
      '05:00', '05:30',
      '06:00', '06:30',
      '07:00', '07:30',
      '08:00', '08:30',
      '09:00', '09:30',
      '10:00', '10:30',
      '11:00', '11:30',
      '12:00', '12:30',
      '13:00', '13:30',
      '14:00', '14:30',
      '15:00', '15:30',
      '16:00', '16:30',
      '17:00', '17:30',
      '18:00', '18:30',
      '19:00', '19:30',
      '20:00', '20:30',
      '21:00', '21:30',
      '22:00', '22:30',
      '23:00', '23:30',
      '23:59'
    ],
    country_code: 'ru'
  }),
  validations: {
    form: {}
  },
  methods: {
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]
      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    resetPassword () {
      HttpClient.httpPatch(['shop.reset', this.$store.state.editId])
        .then(resp => {
          Responses.successRspMessage('Выполнено успешно', 'Сброс пароля')
          this.stopLoading()
        })
        .catch(err => {
          this.stopLoading()
          console.log(err)
        })
    },
    submitForm () {
      this.startLoading()
      this.deactiveUsers = 0
      if ((parseInt(this.userData.status.id) === 1 || parseInt(this.userData.status_id) === 1) && parseInt(this.form.status_id) === 0) {
        this.deactiveUsers = 1
      }
      for (let i in this.form) {
        this.userData[i] = this.form[i]
      }
      this.successSave = true
      const th = this
      console.log(th.deactiveUsers)
      HttpClient.httpPatch(['shop.edit', this.$store.state.editId], this.userData)
        .then(() => {
          if (th.deactiveUsers === 1) {
            HttpClient.httpPut(['auth.logoutAllUserByShop', this.$store.state.editId])
          }
          Responses.successRspMessage('Выполнено успешно', 'Сохранение')
          this.stopLoading()
        })
        .catch(err => {
          this.stopLoading()
          console.log(err)
        })
    },
    clearForm () {
      this.$v.$reset()
      for (let i in this.form) {
        this.form[i] = null
      }
    },
    setUserInfo (response) {
      this.form.name = response.name
      this.form.registry_name = response.registry_name
      this.form.tin = response.tin
      this.form.is_acquiring_enabled = response.is_acquiring_enabled ? 1 : 0
      this.form.city_id = response.city_id
      this.form.terminal_number = response.terminal_number
      this.form.status_id = response.status_id
      // response.settings = response.settings ? response.settings : {}
      this.form.is_tap2phone_enabled = response.settings.is_tap2phone_enabled ? 1 : 0
      this.form.is_check_operday_enabled = response.settings.is_check_operday_enabled ? 1 : 0
      // response.settings.working_hours = response.settings.working_hours ? response.settings.working_hours : {}
      this.form.working_hours_from = response.settings.working_hours.from
      this.form.working_hours_to = response.settings.working_hours.to
      this.userData = response
    },
    getEditData () {
      this.startLoading()
      return HttpClient.httpGet(['shop.getById', this.$store.state.editId])
    },
    changeFilter () {
      this.$store.commit('setFilter', {name: 'city_id', value: this.value})
      this.$emit('changeFilter')
    },
    startLoading () {
      this.loadDialog = false
    },
    stopLoading () {
      this.loadDialog = true
    },
    getCityList () {
      return cacheCt.get()
    },
    closed () {
      if (this.successSave === true) {
        this.$emit('closeDialogSuccess')
      } else {
        this.$emit('closeDialog')
      }
      this.successSave = false
    }
  },
  async created () {
    this.startLoading()
    if (!this.$store.state.editId) {
      this.showDialog = false
      return false
    }
    this.showDialog = true
    const $this = this
    let response = await Promise.all([$this.getCityList(), $this.getEditData()])
    this.cityList = response[0]
    this.setUserInfo(response[1])

    this.country_code = this.$store.state.filtersShop.country_code

    this.stopLoading()
  }
}
</script>

<style lang="scss" scoped>
  .md-dialog {
    max-width: 830px;
    min-height: 450px;
    overflow: auto;
    max-height: 100%;
  }
  .loading-overlay {
    width: 100%;
    height: 100%;
    text-align: center;
    line-height: 450px;
    background: none;
    position: absolute;
    z-index: 9;
  }

  .md-button.ct-green {
    background-color: green !important;
  }

  .md-button.ct-yellow {
    background-color: #e29641 !important;
  }

  .md-button.ct-red {
    background-color: #e91e63 !important;
  }

  .pointer {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/shops/ShopEdit.vue